import { render, staticRenderFns } from "./ImageCollectionFolder.vue?vue&type=template&id=f9f661a8&scoped=true&"
import script from "./ImageCollectionFolder.vue?vue&type=script&lang=ts&"
export * from "./ImageCollectionFolder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f661a8",
  null
  
)

export default component.exports